var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-column", staticStyle: { gap: "16px" } },
    [
      _setup.accessLevel >= 5
        ? _c(
            "v-card",
            { attrs: { outlined: "", dense: "" } },
            [
              _c(
                "v-card-text",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { gap: "16px", "flex-wrap": "wrap" }
                },
                [
                  _c("v-select", {
                    staticStyle: { "max-width": "280px" },
                    attrs: {
                      "hide-details": "",
                      items: _setup.users,
                      "item-text": item =>
                        `${item.employee.id} - ${item.employee.name}`,
                      "item-value": "employee_id",
                      label: "Employee",
                      clearable: "",
                      dense: "",
                      outlined: ""
                    },
                    model: {
                      value: _setup.selectedEmployee,
                      callback: function($$v) {
                        _setup.selectedEmployee = $$v
                      },
                      expression: "selectedEmployee"
                    }
                  }),
                  _c("v-text-field", {
                    staticStyle: { "max-width": "200px" },
                    attrs: {
                      "hide-details": "",
                      type: "date",
                      label: "Date From",
                      dense: "",
                      outlined: ""
                    },
                    model: {
                      value: _setup.filters.date_from,
                      callback: function($$v) {
                        _vm.$set(_setup.filters, "date_from", $$v)
                      },
                      expression: "filters.date_from"
                    }
                  }),
                  _c("v-text-field", {
                    staticStyle: { "max-width": "200px" },
                    attrs: {
                      "hide-details": "",
                      type: "date",
                      label: "Date To",
                      dense: "",
                      outlined: ""
                    },
                    model: {
                      value: _setup.filters.date_to,
                      callback: function($$v) {
                        _vm.$set(_setup.filters, "date_to", $$v)
                      },
                      expression: "filters.date_to"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _setup.fetchAttendanceSheets }
                    },
                    [_vm._v(" Apply ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: { click: _setup.downloadCSV }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-file-excel")
                      ]),
                      _vm._v(" Download CSV ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("v-data-table", {
        attrs: {
          headers: _setup.headers,
          items: _setup.tableState.items,
          loading: _setup.tableState.isLoading,
          dense: ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.has_meal_allowance",
              fn: function({ value }) {
                return [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      value
                        ? _c("v-icon", { attrs: { color: "success" } }, [
                            _vm._v(" mdi-check ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              }
            },
            _setup.accessLevel >= 5
              ? {
                  key: "item.actions",
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", color: "error" },
                          on: {
                            click: function($event) {
                              return _setup.deleteAttendance(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      )
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }